/******************************************************************************
 *** MemberFile ** 조합원 첨부파일
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import FileBox2 from "@/js/common/ui/input/FileBox2";
import Util from "@/js/common/Util";
import CloseIcon from '@mui/icons-material/Close';
interface Props {
    mbrasId     : string;    // 조합원 ID
    mbrasAtchFileId: string;
    setMbrasAtchFileId: Function;
    mbrFile?    : File;      // 첨부파일
    setMbrFile  : React.Dispatch<React.SetStateAction<File | undefined>>
    mbrFileNm   : string;           // 파일명(real file name)
    setMbrFileNm: Function;         // 파일명 setter
    atrzSttsCd?  : string;           // 결재상태코드
    mbrasAtrzDocId?: string;         // 결재 대기 조합원 id
    setAtrzSttsCd?: Function;        // set 결재상태코드
    setCallTime?: Function;          // 목록 재조회
    width?       : number;            // 첨부파일 영역 width
}

const MemberFile = ( {mbrasId, setMbrasAtchFileId, mbrasAtchFileId, mbrFile, setMbrFile, mbrFileNm, setMbrFileNm, atrzSttsCd, mbrasAtrzDocId, setAtrzSttsCd, setCallTime, width = 490}: Props) => {
    // 첨부파일 삭제
    function deleteMbrasFile() {
        AppContext.openAlert({
            title: "첨부파일 삭제",
            msg: "첨부파일을 삭제하시겠습니까?",
            icon: "check",
            confirmText: "파일삭제",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/mbras/new/delete-mbras-file.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        mbrasId: mbrasId,   // 조합원 ID
                        mbrasAtchFileId : mbrasAtchFileId,  // 첨부파일 Id
                        mbrasAtrzDocId : mbrasAtrzDocId,
                        atrzSttsCd: "01",
                    },
                    onSuccessFn: () => {
                        setMbrasAtchFileId(null);
                        setMbrFileNm("");
                        AppContext.openAlert({
                            title: "첨부파일 삭제완료",
                            msg: "조합원 첨부파일이 삭제되었습니다.",
                            icon: "check"
                        });
                        setAtrzSttsCd?.("01");
                        setCallTime?.(Date.now());
                        AppContext.hideSpinner();
                    }
                });
            }
        });
    }

    return (
        <div className="dpFlx aiC bd1 bdrd5 bdcBFBFBF h30" style={{width: `${width}px`}}>
            {Util.isEmpty(mbrasAtchFileId) ?
                <FileBox2 height={36} fontSize={13} width={width}
                    fileExt={[]}       // 파일 확장자 설정: 없으면 기본설정된 파일 확장자 확인
                    file={mbrFile}
                    setFile={(data: any) => {
                        setMbrFile(data);
                    }}
                    mode={["03", "04"].includes(atrzSttsCd ?? "") ? "readonly" : ""}
                />
            :
            <>
                <span className="pl5 Pretendard-Medium fs15 ls07 fc454545 pr20 csP tdU-hover fc5C93FF-hover" style={{width: `${width - 80}px`}} onClick={() => {
                    Axios.dataAccess({
                        url: "system/mbras/new/download-mbras-file.do",
                        methodType: "get",
                        responseType: "blob",
                        paramData: {
                            mbrasId: mbrasId,
                            mbrasAtchFileId: mbrasAtchFileId
                        }
                    });
                }}>{mbrFileNm}</span>

                {/* 파일삭제 버튼: 결재중(03), 결재완료(04) 미표시 */}
                {(atrzSttsCd !== "03" && atrzSttsCd !== "04") && (
                    <div className="csP dpInBlock" onClick={() => {
                        if (mbrasAtchFileId !== null) deleteMbrasFile();
                    }}>
                        <div className="w60 dpFlx aiC jcSb h30 bdrd5 pl5" style={{backgroundColor: 'lightgray'}}>
                            <span className="SpoqaHanSansNeo-Medium fs15 fc222222 ls075 taU fw500 ml5">삭제</span>
                            <CloseIcon style={{ fontSize: 20, color: 'crimson', paddingRight: "5px" }} />
                        </div>
                    </div>
                )}
            </>
            }
        </div>
    )
}

export default MemberFile;